import React, { Component } from 'react';
import ProjectPage from '../../components/ProjectPage';
import Table from '../../components/Table';

class DontMessWithUs extends Component {
  render() {
    return (
    <ProjectPage title="Dont Mess With Us">

      <div className='project-page-part'>

        <Table className="centered" data={{
          Status : "Finished",
          Type : "School project",
          Language : "Java",
          Duration : "3 months",
          Team : "Group of 4",
          Date : "2021"
        }}/>

      </div>

      <div className='project-page-part'>

        <h3>Context :</h3>

        <p className='basic-text'>
          As part of the 2nd year of the DUT I had to develop a multiplayer game in Java.
        </p>

      </div>

      <div className='project-page-part'>

        <h3>Game :</h3>

        <p className='basic-text'>
          Don't Mess With Us is a top-down cooperative multiplayer infiltration game.<br/>
          The objective of the first player (the infiltree) is to go to the end of the level without being found by drones, the infiltree has a reduced field of view and can't see behind walls<br/>
          The objective of the second player (the watcher) is to guide the infiltree through the level, contrary to the infiltree, the watcher can see all the map.
        </p>

      </div>

      <div className='project-page-part'>

        <h3>My contribution :</h3>

        <ul className='basic-text'>
          <li>Basic engine</li>
          <li>Rendering</li>
          <li>Physics</li>
          <li>Player Movement</li>
          <li>Drones</li>
          <li>Networking</li>
          <li>UI</li>
          <li>Basically everything else ...</li>
        </ul>

      </div>

    </ProjectPage>
    );
  }
}

export default DontMessWithUs;